var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading-popup',{attrs:{"title":_vm.loadingTitle,"subtitle":_vm.loadingSubtitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }